import MuiSwitch, { SwitchProps as MuiSwitchProps } from '@mui/material/Switch';

interface SwitchProps extends MuiSwitchProps {}

const Switch = (props: SwitchProps) => {
  return <MuiSwitch data-testid="of-switch" {...props} />;
};

export default Switch;
